<template>
  <div class="mt-2 text-sm text-red-600 dark:text-red-400">
    <template v-if="Array.isArray(errors)">
      <InputError v-for="(errorMessage, errorIndex) in errors as string[]" :key="errorIndex" :message="errorMessage" />
    </template>
    <InputError v-else :message="errors" />
  </div>
</template>

<script setup lang="ts">
  import InputError from './InputError.vue';

  defineProps({
    errors: { type: [String, Array], default: '' },
  });
</script>
